<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid id="main-container">
      <div class="page-title" id="assess-page-title">
        <h2>{{ $t("deforestation.assessmentReport") }}</h2>
        <div class="right-btns">
          <v-btn elevation="0" outlined color="primary" @click="goBack">
            {{ $t("back") }}
          </v-btn>
          <v-btn elevation="0" v-if="defoDetails.status" :outlined="defoDetails.status === 'REQUESTED'
            ? true
            : defoDetails.status === 'CERTIFIED' ||  defoDetails.status === 'CERTIFICATE_READY'
              ? false
              : false
            " color="primary" @click="complianceCertificate()">
            <v-icon left dark> mdi-eye-outline </v-icon>
            {{
              defoDetails.status === "REQUESTED"
              ? this.$t("deforestation.requestComplianceCertificate")
              : defoDetails.status === "CERTIFIED" ||  defoDetails.status === "CERTIFICATE_READY"
                ? this.$t("deforestation.viewCertificate")
                : this.$t("deforestation.requestComplianceCertificate")
            }}
          </v-btn>
          <v-btn elevation="0" color="primary" @click="downloadCompliancePdf()">
            <v-icon left dark> mdi-tray-arrow-down </v-icon>
             {{ $t("deforestation.downloadPDF") }}
          </v-btn>
          <v-btn elevation="0" color="primary" @click="printPage()">
            <v-icon left dark> mdi-printer-outline </v-icon>
            {{ $t("deforestation.print") }}
          </v-btn>
        </div>
      </div>
      <v-card elevation="0" class="mb-5">
        <v-card-title>
          <span class="text-h6 font-weight-bold"> {{ $t("deforestation.farmDetails") }}</span>
        </v-card-title>
        <v-card-text>
          <v-row class="" width="100%">
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle> {{ $t("deforestation.dimitraFarmId") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                            $t("deforestation.tooltip.dimitraFarmId")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ `${defoDetails.farmUUID ? defoDetails.farmUUID : ""}` }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ $t("farm.farmName") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                             $t("deforestation.tooltip.farmName")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{
                          `${defoDetails.farmName ? defoDetails.farmName : ""}`
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ $t("farm.farmRegistrationID") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                             $t("deforestation.tooltip.farmRegistrationId")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{
                          `${defoDetails.farmRegistrationId
                            ? defoDetails.farmRegistrationId
                            : ""
                            }`
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ $t("farm.farmLocation") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                             $t("deforestation.tooltip.farmLocation")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{
                          `${defoDetails.locationName
                            ? defoDetails.locationName
                            : ""
                            }`
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ $t("deforestation.dimitraFermerId") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                             $t("deforestation.tooltip.dimitraFarmerId")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{ `${defoDetails.farmerUUID ? defoDetails.farmerUUID : ""}` }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ $t("farm.farmerName") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                            $t("deforestation.tooltip.farmerName")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{
                          `${defoDetails.farmerName ? defoDetails.farmerName : ""
                          }`
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <v-col lg="3" md="4" sm="6" xs="12">
              <v-card min-height="100" class="pa-2 green2 elevation-0">
                <v-list class="green2">
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-subtitle> {{ $t("farm.farmerRegistrationID") }}
                        <v-tooltip top color="black" max-width="350">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{
                            $t("deforestation.tooltip.farmerRegistrationId")
                          }}</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 mt-2">
                        {{
                          `${defoDetails.farmerRegistrationId
                            ? defoDetails.farmerRegistrationId
                            : ""
                            }`
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card elevation="0">
        <div class="google-map" style="width: 100%; height: 550px; z-index: 0" id="map" ref="googleMap"></div>
      </v-card>
      <v-card elevation="0" class="mt-5">
        <div ref="document" v-if="true">
          <v-row justify="center" class="mb-5">
            <v-col cols="12" sm="8">
              <v-data-table :headers="tableHeaders" :loading="loading" :items="probabilityTable" item-key="id"
                :hide-default-footer="true">
                <template v-slot:top>

                </template>
                <template v-slot:item.title="{ item }">
                  {{ item.title }}
                </template>
                <template v-slot:item.colorCode="{ item }">
                  <div class="d-flex justify-space-between w-75 mr-16">
                    {{ item.color ? item.color : "N/A" }}
                    <div class="color-box" :style="{ background: item.colorCode }"></div>
                  </div>
                </template>
                <template v-slot:item.area="{ item }">
                  {{ item.area ||
                    '0'
                  }} HA
                </template>
                <template v-slot:item.percentage="{ item }">
                  {{ item.percentage ||
                    '0'
                  }}%
                </template>
                <template slot="body.append">
                  <tr class="green2">
                    <th class="bold" colspan="2">{{ $t("deforestation.totalGeofenceArea") }}</th>
                    <th class="bold">{{ this.defoDetails.geofenceArea }} HA</th>
                    <th class="bold">{{ totalProbabilityPercentage }} %</th>
                  </tr>
                </template>

              </v-data-table>
            </v-col>
            <v-col cols="12" sm="4">
              <v-card align-center>
                <v-card-title class="v-data-table-header font-weight-bold"
                  style="height: 48px; font-size: 0.75rem; display: block; text-align: center; vertical-align: center;">
                   {{ $t("deforestation.overallDeforestationProbability") }}
                </v-card-title>
                <v-card-text style="padding: 80px; display: flex; text-align: center; justify-content: center;overflow-x: scroll;">
                  <v-btn small color="warning" rounded class="warning--text" outlined>
                    {{ $t(this.defoDetails.overallProb) }}
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
        <div v-else-if="loading">
          <v-progress-linear indeterminate color="green"></v-progress-linear>
        </div>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import gql from "graphql-tag";
import loading from "@/mixins/LoadingMixin";
import { Loader } from "@googlemaps/js-api-loader";
import axios from "axios";
import html2canvas from "html2canvas";
import DeforestationService from "@/_services/DeforestationService";
export default {
  data() {
    return {
      deforestImage: null,
      opensSomething: false,
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("deforestation.deforestationComplianceReport"),
          disabled: true,
          to: "/forest-assessments",
        },
      ],
      defoDetails: {},
      loading: false,
      selectedReport: {},
      currentGeofenceLatLng: [],
      currentGeofenceLat: 0,
      currentGeofenceLng: 0,
      showGeofenceOnMap: false,
      loader: null,
      google: null,
      mapOptions: {
        mapTypeId: "satellite",
        center: {},
        zoom: 18,
      },
      latitude: 0,
      longitude: 0,
      tableHeaders: [
        { text: this.$t("deforestation.deforestationProbability"), value: "title" },
        { text: this.$t("deforestation.colorCode"), value: "colorCode" },
        { text: this.$t("deforestation.geofenceAarea"), value: "area" },
        { text:this.$t("deforestation.percentageOfGeofenceArea"), value: "percentage" }
      ],
      tableHeadersRight: [{ text:this.$t("deforestation.overallDeforestationProbability"), value: "overallDeforestationProbability" }],
      overallDeforestation: { rows: [{ id: 1, status: 'Low Deforestation Probibility' }] },
      probabilityTable: [],
      totalProbabilityArea: 0,
      totalProbabilityPercentage: 0
    };
  },
  computed: {
    deforestationImage() {
      if (this.defoDetails) {
        const satelliteImage = this.defoDetails.sateliteResponse && this.defoDetails.sateliteResponse.find(item => item.reportName === 'Final Detection')
        if (satelliteImage) {
          return satelliteImage.imagePath
        }
      }
      return ''
    },
  },
  async created() {
    await this.getDeforestationReport()
  },
  async mounted() {
    this.loading = true;
    await this.getDeforestationReport()
    this.mapOptions.center.lat = this.defoDetails.centerLatitude;
    this.mapOptions.center.lng = this.defoDetails.centerLongitude;
    const data = await this.proxyImage(this.deforestationImage)
    this.deforestImage =  'data:image/jpeg;base64,' + data
    try {
      const loader = await new Loader({
        apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
        libraries: ["places", "map", "geometry"],
      })
        .load()
        .then((google) => {
          this.google = google;
          this.initializeMap(google);
        })
        .catch((e) => {
          console.log("Map", e);
        });
      this.loader = loader;
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    async calculateCoordsForPolygun(google) {
            const centerCoordinates = {
                lat: Number.parseFloat(this.mapOptions.center.lat),
                lng: Number.parseFloat(this.mapOptions.center.lng)
            }
            const geometry = await google.maps.importLibrary("geometry");
            const radius = Number.parseFloat(this.defoDetails.radius) * Math.sqrt(2.0);
            const center = new google.maps.LatLng(centerCoordinates);

            const sw = geometry.spherical.computeOffsetOrigin(center, radius, 45.0);
            const ne = geometry.spherical.computeOffsetOrigin(center, radius, 225.0);
            return [sw, ne]
        },
        async proxyImage(){
            const location = this.deforestationImage
            if(location){
                return  await DeforestationService.getProxyImage(location)
            }
        },
    goBack() {
      this.$router.push({
        name: "DeforestationList",
      });
    },
    async getDeforestationReport() {
      this.$apollo.queries.deforestation.skip = false;
      await this.$apollo.queries.deforestation.refetch();
    },
    getPolygonBounds() {
      console.log(this.polygon);
      var paths = this.polygon.getPaths();
      var bounds = new this.google.maps.LatLngBounds();
      paths.forEach(function (path) {
        var ar = path.getArray();
        for (var i = 0, l = ar.length; i < l; i++) {
          bounds.extend(ar[i]);
        }
      });
      return bounds;
    },
    async initializeMap(google) {
      this.google = google;
      const mapContainer = this.$refs.googleMap;
      this.map = await new google.maps.Map(mapContainer, this.mapOptions);
      await this.createPolygon();

      let bounds = this.getPolygonBounds();
      if (this.defoDetails.coordinates.length && this.defoDetails.reportType == 'REGISTERED_FARM') {
            await this.createPolygon()
            bounds = this.getPolygonBounds()
        } else {
            const swne = await this.calculateCoordsForPolygun(google)
            bounds = new google.maps.LatLngBounds(swne[0], swne[1]);
        }
 
      // console.log(bounds, 'bounds')
      // The photograph is courtesy of the U.S. Geological Survey.
      const srcImage = this.deforestationImage;
      console.log('overlay', srcImage)
      // The custom USGSOverlay object contains the USGS image,
      // the bounds of the image, and a reference to the map.
      class USGSOverlay extends google.maps.OverlayView {
        bounds_;
        image_;
        div_;
        constructor(bounds, image) {
          super();
          // Initialize all properties.
          this.bounds_ = bounds;
          this.image_ = image;
          // Define a property to hold the image's div. We'll
          // actually create this div upon receipt of the onAdd()
          // method so we'll leave it null for now.
          this.div_ = null;
        }
        /**
         * onAdd is called when the map's panes are ready and the overlay has been
         * added to the map.
         */
        onAdd() {
          this.div_ = document.createElement("div");
          this.div_.style.borderStyle = "none";
          this.div_.style.borderWidth = "0px";
          this.div_.style.position = "absolute";

          // Create the img element and attach it to the div.
          const img = document.createElement("img");

          img.src = this.image_;
          // console.log(img, 'img')
          img.style.width = "100%";
          img.style.height = "100%";
          img.style.position = "absolute";
          this.div_.appendChild(img);

          // Add the element to the "overlayLayer" pane.
          const panes = this.getPanes();

          panes.overlayLayer.appendChild(this.div_);
        }
        draw() {
          // We use the south-west and north-east
          // coordinates of the overlay to peg it to the correct position and size.
          // To do this, we need to retrieve the projection from the overlay.
          const overlayProjection = this.getProjection();
          // Retrieve the south-west and north-east coordinates of this overlay
          // in LatLngs and convert them to pixel coordinates.
          // We'll use these coordinates to resize the div.
          const sw = overlayProjection.fromLatLngToDivPixel(
            this.bounds_.getSouthWest()
          );
          // console.log(sw, 'sw')
          const ne = overlayProjection.fromLatLngToDivPixel(
            this.bounds_.getNorthEast()
          );
          // console.log(ne, 'ne')

          // Resize the image's div to fit the indicated dimensions.
          if (this.div_) {
            this.div_.style.left = sw.x + "px";
            this.div_.style.top = ne.y + "px";
            this.div_.style.width = ne.x - sw.x + "px";
            this.div_.style.height = sw.y - ne.y + "px";
            // console.log(ne.x - sw.x + "px", 'width')
            // console.log(sw.y - ne.y + "px", 'height')
          }
        }
        /**
         * The onRemove() method will be called automatically from the API if
         * we ever set the overlay's map property to 'null'.
         */
        onRemove() {
          if (this.div_) {
            this.div_.parentNode.removeChild(this.div_);
            this.div_ = null;
          }
        }
      }
      this.map.fitBounds(bounds);
      const srcImage1 = this.deforestImage
      const overlay = new USGSOverlay(bounds, srcImage1, this.map);
      console.log(overlay)

      overlay.setMap(this.map);
    },
    async createPolygon() {
      if (this.polygon != null) this.polygon.setMap(null);
      this.polygon = await new this.google.maps.Polygon({
        paths: this.currentGeofenceLatLng,
        strokeColor: "transparent",
        // strokeColor: "#1F5D51",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: "#E5F8F1",
        fillOpacity: 0,
        editable: false,
        draggable: false,
        icon: this.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
      });

      this.polygon.setMap(this.map);
      return Promise.resolve(true);
    },
    printPage() {
      const mainnav = document.getElementById("mainnav");
      const appbar = document.getElementById("appbar");
      const breadcrum = document.getElementById("breadcrum");
      const assessPageTitle = document.getElementById("assess-page-title");

      mainnav.style.display = "none";
      appbar.style.display = "none";
      breadcrum.style.display = "none";
      assessPageTitle.style.display = "none";

      window.print();

      mainnav.style.removeProperty('display');
      appbar.style.removeProperty('display');
      breadcrum.style.removeProperty('display');
      assessPageTitle.style.removeProperty('display');

    },
    async downloadCompliancePdf() {
      this.startLoading();
      await new Promise((resolve) => setTimeout(resolve, 100));
      let fileName = `file_${new Date().getTime()}.jpg`;
      let el = this.$refs.googleMap;
      let canvasRes = await html2canvas(el, { scale: 2, useCORS: true });
      let outputDataUrl = canvasRes.toDataURL("image/jpeg");
      var imageBlob = this.dataURLtoBlob(outputDataUrl);
      const formData = new FormData();
      formData.append("file", imageBlob, fileName);
      formData.append("id", this.$route.params.id);
      // const data = await DeforestationService.downloadCompliancePdf(formData);

      const { data } = await axios.post(process.env.VUE_APP_FARMER_APP_BASE_URL + `/deforestation/assessment/pdf-download`, formData);
      // console.log('data', data, data.location);
      // console.log('data data', data.data, data.data.location);
      //await this.downloadBlobFile(data.location);
      const link = document.createElement("a");

      link.href = data.data.location;
      link.target = "_blank";
      link.click();
      this.stopLoading();
    },
    dataURLtoBlob(dataURL) {
      var arr = dataURL.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new Blob([u8arr], { type: mime });
    },
    async complianceCertificate() {
      if (this.defoDetails.status === "CERTIFIED" || this.defoDetails.status === "CERTIFICATE_READY"  ) {
        this.$router.push({
          name: "ComplianceCertificationEudrAssessment",
          params: { id: this.$route.params.id }
        });
      }
      else {
        this.startLoading()
        // console.table(gdata, gdata)
        const id = this.$route.params.id;
        this.$apollo.mutate({
          // Query
          mutation: gql`mutation ($reportId: Int!) {
          requestComplianceCertificate(
						reportId: $reportId
					)
        		}`,
          // Parameters
          variables: {
            reportId: Number(id),
          },
        }).then(async res => {
          if (res.data.requestComplianceCertificate) {
            this.$notify({
              title: `Success`,
              text: 'Compliance requested successfully.',
              type: "success",
            });
            this.stopLoading()
          }
          this.defoDetails.status = "CERTIFIED"
        }).catch(async error => {
          this.$notify({
            title: `Complaince cannot be requested.`,
            text: error.message.split(":")[1],
            // text: "The server couldn't process your request, please contact your admin for further details",
            type: "error",
            position: "center",
            duration: 1000000
          });
          this.stopLoading()
        })
      }
    },
  },
  mixins: [loading],
  apollo: {
    deforestation: {
      query() {
        return gql`
          query deforestation($id: Int!) {
            deforestation(id: $id) {
              id
              userId
              radius
              reportType
              farmId
              farmName
              farmRegistrationId
              farmerName
              farmerRegistrationId
              centerLatitude
              centerLongitude
              locationName
              geofenceArea
              createdAt
              status
              country
              state
              isDeleted
              farmUUID
              farmerUUID
              coordinates {
                latitude
                longitude
              }
              farm {
                farmName
              }
              sateliteResponse {
                imageName
                imagePath
                imgS3Key
                reportName
                satelliteSource
                status
                createdAt
              }
              createdAt
              highProb
              highProbPercentage
              lowProb
              lowProbPercentage
              zeroProb
              zeroProbPercentage
              overallProb
              reportType
              radius
            }
          }
        `;
      },
      variables() {
        return {
          id: +this.$route.params.id,
        };
      },
      update: (data) => data.deforestation,
      async result({ data }) {
        this.startLoading();
        this.defoDetails = await data.deforestation;
        var codes = [];
        data.deforestation.coordinates.map(function (elm) {
          codes.push({
            lat: parseFloat(elm["latitude"]),
            lng: parseFloat(elm["longitude"]),
          });
        });
        this.currentGeofenceLatLng = codes;
        this.currentGeofenceLat = this.defoDetails.centerLatitude;
        this.currentGeofenceLng = this.defoDetails.centerLongitude;
        this.showGeofenceOnMap = true;
        this.mapOptions.center.lat = Number.parseFloat(
          this.defoDetails.centerLatitude
        );
        this.mapOptions.center.lng = Number.parseFloat(
          this.defoDetails.centerLongitude
        );
        this.defoDetails.coordinates = this.defoDetails.coordinates.map(
          (x) => {
            return {
              lat: x.latitude,
              lng: x.longitude,
            };
          }
        );
        this.polygonCoords = this.defoDetails.coordinates;

        this.probabilityTable = [{
          title: this.$t("deforestation.high"),
          color: 'Red',
          colorCode: "#F03737",
          area: this.defoDetails.highProb,
          percentage: this.defoDetails.highProbPercentage
        },
        {
          title: this.$t("deforestation.low"),
          area: this.defoDetails.lowProb,
          colorCode: "#FFB443",
          color: "Yellow",
          percentage: this.defoDetails.lowProbPercentage
        },
        {
          title: this.$t("deforestation.zeroOrNegigible"),
          area: this.defoDetails.zeroProb,
          colorCode: "#F1F4F7",
          color: "Transparent",
          percentage: this.defoDetails.zeroProbPercentage
        }
        ]
        this.totalProbabilityArea = this.defoDetails.lowProb + this.defoDetails.highProb + this.defoDetails.zeroProb
        this.totalProbabilityPercentage = this.defoDetails.lowProbPercentage + this.defoDetails.highProbPercentage + this.defoDetails.zeroProbPercentage
        this.stopLoading();
        this.loading = false
      },
      fetchPolicy: "no-cache",
    },
  },
};
</script>
<style scoped>
.right-btns {
  display: flex;
  gap: 0px 10px;
}

.color-box {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 5px;
  margin-left: 10px;
}
</style>
